import * as React from "react";
import { useContext } from "react";
import { Search, SearchProps } from "./components/Search";
import { useQueryParams } from "../../hooks/useQueryParams";
import { SearchContext } from "../SearchContext";
import { Cell } from "./components/Cell";
import { Field } from "./components/Field";
import { Picker } from "./components/Picker";

interface Data {
    q: string;
    countries: string[];
    programmes: string[];
}

export const IbybSearch: React.FC<SearchProps> = ({ container, type }) => {
    const { qsOverride, countries, programmes } = useContext(SearchContext);
    const params = useQueryParams(qsOverride);

    const fields: Data = {
        q: params.getQuery(),
        countries: params.getCountries(),
        programmes: params.getProgrammes()
    };

    return (
        <Search container={container} type={type} data={fields}>
            <Cell width="100">
                <Field<Data, "q"> name="q">
                    {(value, setValue) => (
                        <input
                            className="field"
                            type="text"
                            placeholder="Search by school name or location..."
                            value={value}
                            onChange={e => setValue(e.target.value)}
                        />
                    )}
                </Field>
            </Cell>

            <Cell width="50">
                <Field<Data, "countries"> name="countries">
                    {(value, setValue) => (
                        <Picker
                            label="Countries"
                            all={{ value: "all", label: "All" }}
                            selected={value}
                            onChange={setValue}
                            options={countries}
                        />
                    )}
                </Field>
            </Cell>

            <Cell width="50">
                <Field<Data, "programmes"> name="programmes">
                    {(value, setValue) => (
                        <Picker
                            label="Programmes"
                            all={{ value: "all", label: "Any" }}
                            selected={value}
                            onChange={setValue}
                            options={programmes}
                        />
                    )}
                </Field>
            </Cell>
        </Search>
    );
};
